export const locations = {
    title: "লোকেশন",
    description: "আপনার শাখা (যেখানে বিক্রি হয়) ও গুদাম (শুধু স্টক)।",
    add: "লোকেশন যোগ করুন",
    edit: "লোকেশন সম্পাদনা",
    back: "সব লোকেশন",
    columns: { name: "নাম", type: "ধরন", billPrefix: "বিল প্রিফিক্স", status: "অবস্থা" },
    types: { branch: "শাখা", warehouse: "গুদাম" },
    statuses: { active: "সক্রিয়", inactive: "নিষ্ক্রিয়" },
    filters: { type: "ধরন", status: "অবস্থা", all: "সব" },
    isDefault: "অনলাইন অর্ডারের ডিফল্ট",
    fields: {
        type: "ধরন",
        name: "নাম",
        billPrefix: "বিল প্রিফিক্স",
        billPrefixHint: "১–৬টি অক্ষর বা সংখ্যা, পিওএস বিলে ছাপা হয় (যেমন B1)।",
        address: "ঠিকানা",
        phone: "ফোন",
        receiptHeader: "রসিদের শিরোনাম",
        receiptHeaderHint: "এই শাখার রসিদের উপরে ছাপা হয়।",
        shopVisible: "অনলাইন শপে দেখান",
        shopVisibleHint: "ক্রেতারা “আমাদের দোকান”-এ এই শাখার নাম, ঠিকানা, ফোন ও খোলার সময় দেখবেন।",
        openingHours: "খোলার সময়",
        openingHoursHint: "ক্রেতারা যেভাবে পড়বেন, যেমন শনি–বৃহস্পতি সকাল ১০টা–রাত ৯টা",
        mapUrl: "ম্যাপ লিংক",
        mapUrlHint: "পথ দেখানোর জন্য Google Maps (বা যেকোনো https://) লিংক।",
    },
    empty: "এখনো কোনো লোকেশন নেই। প্রথম শাখা যোগ করুন।",
    created: "লোকেশন যোগ হয়েছে।",
    saved: "লোকেশন সংরক্ষণ হয়েছে।",
    makeDefault: "অনলাইন অর্ডারের ডিফল্ট করুন",
    madeDefault: "ডিফল্ট লোকেশন পরিবর্তন হয়েছে।",
    deactivate: "নিষ্ক্রিয় করুন",
    activate: "সক্রিয় করুন",
    deactivateTitle: "এই লোকেশন নিষ্ক্রিয় করবেন?",
    deactivateBody: "এর রেজিস্টারগুলোও নিষ্ক্রিয় হবে। রিপোর্টে এর ইতিহাস থাকবে।",
    deactivated: "লোকেশন নিষ্ক্রিয় হয়েছে।",
    activated: "লোকেশন সক্রিয় হয়েছে।",
    conflict: "অন্য কেউ এই লোকেশন পরিবর্তন করেছেন। সর্বশেষ তথ্য দেখানো হচ্ছে; আবার পরিবর্তন করুন।",
    registers: {
        title: "রেজিস্টার",
        description: "এই শাখার ক্যাশ কাউন্টার। প্রতিটি পিওএস কম্পিউটার একটির সাথে যুক্ত থাকে।",
        name: "রেজিস্টারের নাম",
        add: "রেজিস্টার যোগ করুন",
        added: "রেজিস্টার যোগ হয়েছে।",
        rename: "নাম বদলান",
        renamed: "রেজিস্টারের নাম বদলানো হয়েছে।",
        deactivated: "রেজিস্টার নিষ্ক্রিয় হয়েছে।",
        activated: "রেজিস্টার সক্রিয় হয়েছে।",
        empty: "এখনো কোনো রেজিস্টার নেই।",
        warehouse: "গুদামে রেজিস্টার থাকে না।",
    },
};
//# sourceMappingURL=locations.js.map